<template>
  <div class="index">
    <div class="information-container">
      <div class="centered add-document">
        <router-link :to="{ name: 'BrokerInformationCreator' }" class="button-wrapper link" >
          <a class="button is-info">+</a> Добавить информацию
        </router-link>
      </div>
      <div class="is-multiline documents" v-if="data">
        <b-table html
          :data="data"
          :bordered="false"
          :striped="false"
          :narrowed="false"
          :selectable="false"
          :checkable="true"
          :mobile-cards="false"
          :paginated="true"
          :per-page="50"
          render-html
          @dblclick="edit"
          @check="checked">
          <b-table-column field="date" label="Дата публикации" sortable :format="formatDate"></b-table-column>
          <b-table-column field="title" label="Заголовок" sortable></b-table-column>
        </b-table>
        <div>
          <button class="button is-danger" :disabled="!data.length" @click="deleteItems">Удалить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrokerInformationItem from 'components/Information/BrokerInformationItem'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'

export default {
  name: 'BrokerInformation',
  data () {
    return {
      checkItems: []
    }
  },
  computed: {
    ...mapState(['documents']),
    data () {
      return deepcopy(this.documents)
    }
  },
  created () {
    this.getBrokerInformation()
  },
  methods: {
    ...mapActions(['getBrokerInformation', 'addBrokerInformation', 'deleteBrokerInformation']),
    edit (brokerInformation, e) {
      this.$router.push({ name: 'BrokerInformationEditor', params: { id: brokerInformation.id } })
    },
    checked (items, item) {
      this.checkItems = items
    },
    formatDate (value) {
      const date = new Date(value);
      const dateString = date.toLocaleDateString();
      const timeString = date.toLocaleTimeString();
      return `<span class="tag is-primary">${dateString} ${timeString}</span>`;
    },
    deleteItems () {
      this.$dialog.confirm({
        message: 'Действительно удалить?',
        onConfirm: () => {
          for (const item of this.checkItems) {
            this.deleteBrokerInformation(item.id)
            .then(() => this.$forceUpdate())
          }
        }
      })
    }
  },
  components: { BrokerInformationItem }
}
</script>

<style scoped>
.information-container {
  padding: 25px 0 60px;
  margin: 15px 0 0;
  max-width: 800px;
  margin: 0 auto;
}
.documents {
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// BrokerInformation.vue?2b72d006